import { ArrowUpRight, MapPin, Phone } from "lucide-react";

export default function Footer({ mapsUrl, phoneTel }) {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div>
            <div className="footer-kicker">Hashtag MultiCuisine Restaurant & Garden</div>
            <h2>See you<br />at the table.</h2>
          </div>
          <div className="footer-contact">
            <p>Fine dining, open-air celebrations, and a little more room for everyone in Varanasi.</p>
            <a href={phoneTel} data-testid="footer-phone-link"><Phone size={15} aria-hidden="true" /><span>080040 80054</span></a>
            <a href={mapsUrl} target="_blank" rel="noreferrer" data-testid="footer-directions-link"><MapPin size={15} aria-hidden="true" /><span>Open in Google Maps</span><ArrowUpRight size={15} aria-hidden="true" /></a>
            <div className="footer-socials" aria-label="Hashtag social links">
              <a href="https://www.instagram.com/hashtagrestro.vns/?hl=en" target="_blank" rel="noreferrer" aria-label="Hashtag on Instagram" title="Instagram" data-testid="footer-instagram-link"><span className="social-mark" aria-hidden="true">ig</span></a>
              <a href="https://www.facebook.com/Hashtagrestro.vns/" target="_blank" rel="noreferrer" aria-label="Hashtag on Facebook" title="Facebook" data-testid="footer-facebook-link"><span className="social-mark" aria-hidden="true">f</span></a>
              <a href="https://www.zomato.com/varanasi/hastag-multi-cuisine-restro-garden-pandeypur" target="_blank" rel="noreferrer" aria-label="Hashtag on Zomato" title="Zomato" data-testid="footer-zomato-link"><span className="social-mark" aria-hidden="true">z</span></a>
            </div>
          </div>
        </div>
        <div className="footer-bottom"><span>RingRoad · Chandmari · Varanasi</span><span>Open until 11 pm</span></div>
      </div>
    </footer>
  );
}
